import api from "./api";

const GitLabAPI = {
    getPipelines: (page, perPage) => api.get(`/admin/gitlab/pipelines`, { params: { page, perPage } }),
    getPipelineDetails: (id) => api.get(`/admin/gitlab/pipelines/${id}`),
    getPipelineJobs: (id) => api.get(`/admin/gitlab/pipelines/${id}/jobs`),
    triggerPipeline: (refName) => api.post(`/admin/gitlab/pipelines/trigger`, null, { params: { refName } }),
    cancelPipeline: (id) => api.post(`/admin/gitlab/pipelines/${id}/cancel`),
    retryPipeline: (id) => api.post(`/admin/gitlab/pipelines/${id}/retry`),
    retryJob: (id) => api.post(`/admin/gitlab/jobs/${id}/retry`)
};

export default GitLabAPI;
